import { render, staticRenderFns } from "./InfoTicket.partial.vue?vue&type=template&id=e1ce5a60&scoped=true"
import script from "./InfoTicket.partial.vue?vue&type=script&lang=js"
export * from "./InfoTicket.partial.vue?vue&type=script&lang=js"
import style0 from "./InfoTicket.partial.vue?vue&type=style&index=0&id=e1ce5a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ce5a60",
  null
  
)

export default component.exports